/* eslint-disable */
/**
 * Selects the root filters from the state
 * @param {any} state The state
 * @returns {any} The root filters
 */
const getFilters = (state) => state.filters;

export default getFilters;
